import axios from "./axiosConfig";

const clientsService = {
        getAll() {
            return axios.get("/clients");
        },

        // Búsqueda unificada en servidor: devuelve { clients, branches }
        // sin traer todo el catálogo de la base de datos.
        search(q, limit = 15) {
            return axios.get("/clients/search", { params: { q, limit } });
        },

        getOne(id) {
            return axios.get(`/clients/${id}`);
        },

        create(data) {
            return axios.post("/clients", data);
        },

        update(id, data) {
            return axios.put(`/clients/${id}`, data);
        },

        delete(id) {
            return axios.delete(`/clients/${id}`);
    }
};

export default clientsService;
